import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./DetailHorizontalList.module.scss";
import Detail from "../Detail/Detail";

export interface DetailHorizontalListProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const DefaultDetailHorizontalList = (props: DetailHorizontalListProps) => {
    const { className, children, ...otherProps } = props;
    return (
        <div className={clsx(styles.detailRow, className)} data-deci-detail-horizontal-list="true" {...otherProps}>
            {children}
        </div>
    );
};

const DetailHorizontalList = createPluggable<DetailHorizontalListProps>("deci.detailHorizontalList", DefaultDetailHorizontalList);

export default Object.assign(DetailHorizontalList, {
  Item: Detail,
  Icon: Detail.Icon,
  Title: Detail.Title,
  Content: Detail.Content,
});
